export const GET_GROUPS = 'GET_GROUPS';
export const SET_GROUPS_PAGINATION = 'SET_GROUPS_PAGINATION';
export const SET_GROUPS_FILTERS = 'SET_GROUPS_FILTERS';
export const RESET_GROUPS = 'RESET_GROUPS';
export const TOGGLE_GROUP = 'TOGGLE_GROUP';
export const ADD_GROUP = 'ADD_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const GET_GROUP_BY_ID = 'GET_GROUP_BY_ID';
export const RESET_GROUP_FORM = 'RESET_GROUP_FORM';
export const MODIFY_EDITING_GROUP = 'MODIFY_EDITING_GROUP';



// WEBPACK FOOTER //
// src/modules/secured/modules/groups/constants/groups_constants.js